import React, { useState, useEffect } from 'react';

const HeroSection: React.FC = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState<number>(0);
  const words: string[] = ['>100 markets', '24/7', '>$10B volume'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <div className="hero-main">
          <div className="hero-text">
            <div>We</div>
            <div className="italic-word">trade</div>
            <div className="word-carousel">
              {words.map((word: string, index: number) => (
                <span 
                  key={index}
                  className={`cword ${index === currentWordIndex ? 'visible' : ''}`}
                >
                  {word === '24/7' ? (
                    <>24<span className="slash-divider">/</span>7</>
                  ) : (
                    word
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 